const CompanyStory = () => {
  const decorativePatternUrl = "/assest/blog_bg-17.png";

  return (
    <section className="bg-white py-12 sm:py-16 md:py-20 lg:py-20">
      <div className="container px-5 sm:px-6 lg:px-[15px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-4 lg:gap-x-6 items-center">
          
          <div className="lg:col-span-5 relative flex items-center mb-10 sm:mb-12 lg:mb-0 min-h-[280px] sm:min-h-[350px] lg:min-h-[450px]">
            <img
                src={decorativePatternUrl}
                alt="Decorative background pattern"
                className="absolute inset-0 w-full h-full object-contain opacity-20"
            />
            <div className="relative w-full pl-0 sm:pl-4 lg:pl-18 xl:pl-12">
              <span className="section-label mb-3 sm:mb-4 block text-xs sm:text-sm">
                Nurturing Success
              </span>
              <h2 className="font-display font-bold text-brand-navy text-3xl sm:text-4xl lg:text-[42px] leading-tight">
                Your Trusted <br />
                Partner in <br />
                Manpower and <br />
                Staffing Solutions
              </h2>
            </div>
          </div>
          
          <div className="lg:col-span-7">
            <blockquote className="mb-6 sm:mb-8">
              <p className="quote-text text-base sm:text-lg md:text-xl">
                "There are painters who transform the sun into a yellow spot, but there are others who, thanks to their art and intelligence, transform a yellow spot into the sun."
              </p>
              <footer className="quote-attribution mt-3 sm:mt-4 block text-sm">
                - Pablo Picasso
              </footer>
            </blockquote>

            <div className="space-y-4 sm:space-y-6 text-sm sm:text-base text-text-dark leading-[1.7] font-body">
              <p>
                IMMACULATE was founded in Mumbai adhering to such a thought of transformation, especially for businesses; meeting their manpower and staffing needs, preparing them for a bold present and a promising future.
              </p>
              <p>
                We began with a modest workforce and today, we are at the forefront of meeting the demands of the rapidly expanding industry. We currently have over multiple employees who are deployed at over multiple organizations and over multiple locations across the India.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CompanyStory;